import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 8px 4px;
  font-size: 13px;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;

  a {
    white-space: nowrap;
  }
`;

export const Sections = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 12px;
`;

export const SectionBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 10px 12px;
  border: 1px solid ${({ theme }) => theme.colors.neutral.gray2};
  border-radius: 8px;
  background: ${({ theme }) => theme.colors.neutral.white};

  h3 {
    margin: 0;
    font-size: 13px;
  }

  span,
  a {
    font-size: 12px;
    word-break: break-word;
  }
`;

export const Thumbs = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;

  img {
    width: 56px;
    height: 56px;
    object-fit: cover;
    border-radius: 4px;
  }
`;
